import { useContext } from "react";
import { dataContext } from "../context/context";

import Why from '../components/sections/why/why';
import Webdesign from '../components/sections/webdesign/webdesign';
import Bots from '../components/sections/bots/bots';
import Crm from '../components/sections/crm/crm';

import loadingIcon from "../assets/images/loading.svg";
import errorIcon from "../assets/images/error.svg";
import Mobileapplications from "../components/sections/mobileapplications/mobileapplications";


export const Page = () => {

    const { data, loading, error  } = useContext(dataContext);

    if (loading) return (

        <main id="loading">
            <section>
                <div className="inner_block">

                    <h2><img src={loadingIcon} alt="Загрузка..." /> Загрузка...</h2>

                </div>
            </section>
        </main>

    );

    else if (!data || error) return (

        <main id="error">
            <section>
                <div className="inner_block">

                    <h2><img src={errorIcon}  alt="Ошибка загрузки!" /> Ошибка загрузки!</h2>

                </div>
            </section>
        </main>


    );

    else {

        const section = data.sectionsdata.find(s => s.id === 1);
        const paragraphs = section ? section.paragraphsdata : [];

         return (
            <main>

                <h1>{section.h1}</h1>
                {
                paragraphs.map((par, index) => (
                <section>
                    <div className="semitransparent_block">
                    {par.text}
                    </div>
                </section>
                    ))
                }

                <Why />
                <Webdesign />
                <Mobileapplications />
                <Bots />
                <Crm />

            </main>
        )
    }
}